import { create } from "zustand";
import {  addSetting, serviceablePincode, settings, uploadServiceablePincode,nonserviceableCombination,uploadNonServiceablecombination, blockedCustomers,uploadBlockedCustomers } from "../api_layer/api";


export const useSettingsStore = create((set) => ({
    settingData: [],
    pinCode:[],
    serviceableCombination:[],
    settingLoading: false,
    addSettingLoading: false,
    serviceableLoading:false,
    blockedCustomersData:[],
    uploadLoading:false,
    error: null,
    fetchSettingsData: async () => {
      try {
        set({ settingLoading: true, error: null });
        const response = await settings();
        set({ settingData: response.data, settingLoading: false });
      } catch (error) {
        set({ error: error.message, settingLoading: false });
      }
    },
    addSettings: async (payload, setToaster,fetchSettingsData, handleModalClose) => {
      try {
        set({ addLoading: true, error: null });
        const response = await addSetting(payload);
        setToaster("Product", "Product added successfully", "success");
        fetchSettingsData();
        handleModalClose();
        set({ addLoading: false });
      } catch (error) {
        handleModalClose();
        setToaster("Product", "Adding product failed", "danger");
        set({ error: error.message, addLoading: false });
      }
    },
    getPincodeData: async () => {
        try {
          set({ serviceableLoading: true, error: null });
          const response = await serviceablePincode();
          set({pinCode:response?.data, serviceableLoading: false });
        } catch (error) {
          set({ error: error.message, serviceableLoading: false });
        }
      },
      getNonserviceableCombinatin: async()=>{
        try {
          set({ serviceableLoading: true, error: null });
          const response = await nonserviceableCombination();
          set({serviceableCombination:response?.data, serviceableLoading: false });
        } catch (error) {
          set({ error: error.message, serviceableLoading: false });
        }
      },
      getBlockedCustomersData: async () => {
        try {
          set({ serviceableLoading: true, error: null });
          const response = await blockedCustomers();
          set({blockedCustomersData:response?.data, serviceableLoading: false });
        } catch (error) {
          set({ error: error.message, serviceableLoading: false });
        }
      },

      uploadPincode: async (payload, setToaster,fetchSettingsData, handleModalClose,onCloseMoreModal) => {
        try {
          set({ uploadLoading: true, error: null });
          const response = await uploadServiceablePincode(payload);
          setToaster("Medicines", "Updated successfully", "success");
          fetchSettingsData();
          handleModalClose();
          onCloseMoreModal()
         set({ uploadLoading: false });
        } catch (error) {
          handleModalClose();
          onCloseMoreModal()
          setToaster("Medicines", "Failed to update", "danger");
          set({ error: error.message, uploadLoading: false });
        }
      },
  uploadNonserviceablecombination: async (payload, setToaster,fetchSettingsData, handleModalClose,onCloseMoreModal) => {
        try {
          set({ uploadLoading: true, error: null });
          const response = await uploadNonServiceablecombination(payload);
          setToaster("Medicines", "Updated successfully", "success");
          fetchSettingsData();
          handleModalClose();
          onCloseMoreModal()
          set({ uploadLoading: false });
        } catch (error) {
          handleModalClose();
          onCloseMoreModal()
          setToaster("Medicines", "Failed to update", "danger");
          set({ error: error.message, uploadLoading: false });
        }
      },
      uploadblockedCustomers: async (payload, setToaster,fetchSettingsData, handleModalClose,onCloseMoreModal) => {
        try {
          set({ uploadLoading: true, error: null });
          const response = await uploadBlockedCustomers(payload);
          setToaster("Medicines", "Updated successfully", "success");
          fetchSettingsData();
          handleModalClose();
          onCloseMoreModal()
          set({ uploadLoading: false });
        } catch (error) {
          handleModalClose();
          onCloseMoreModal()
          setToaster("Medicines", "Failed to update", "danger");
          set({ error: error.message, uploadLoading: false });
        }
      },
  }));
  